import styled from "@emotion/styled";

export const BoxHeadTableCell = styled.div`
  padding: ${p => p.theme.space[3]}px;
  font-size: 14px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 16px;
  }
`;
